import { take, select, put, call } from 'redux-saga/effects';
import { SET_CENTRIFUGO_CONNECTED } from '../../../constants/centrifugo';
import {
  brandSelector,
  channelSelector,
  proxyPrefixSelector,
  userTokenSelector,
} from '../../../reducers/app/params';
import {
  operatorIdSelector,
  frontApiPrefixSelector,
} from '../../../reducers/app/configuration';
import { getAPI } from '../../../../services/api';
import { logger } from '../index';
import { setCentrifugoInitialData } from '../../../actions/domain/centrifugo/state';
import {
  CENTRIFUGO_INITIAL_DATA_QUERY_PARAM,
  CENTRIFUGO_INITIAL_DATA_URL,
} from '../../../../constants/centrifugo';
import { EVA_API_SERVICE_NAME, HTTP_HEADERS } from '../../../../constants/api';

function getQueryParams(projects = []) {
  const queryParams = new URLSearchParams();
  for (const project of projects) {
    queryParams.append(CENTRIFUGO_INITIAL_DATA_QUERY_PARAM.PROJECT, project);
  }
  queryParams.append(
    CENTRIFUGO_INITIAL_DATA_QUERY_PARAM.PRODUCT_TYPE,
    EVA_API_SERVICE_NAME
  );

  return queryParams;
}

function* getHeaders() {
  const brand = yield select(brandSelector);
  const channel = yield select(channelSelector);
  const token = yield select(userTokenSelector);
  const operatorId = yield select(operatorIdSelector);
  const headers = {
    [HTTP_HEADERS.BRAND]: brand,
    [HTTP_HEADERS.CHANNEL]: channel,
    [HTTP_HEADERS.OPERATOR_ID]: operatorId,
    ...(token ? { [HTTP_HEADERS.AUTHORIZATION]: `Token ${token}` } : {}),
  };

  return headers;
}

function* fetchCentrifugoInitialData(projects = []) {
  const { fetch } = getAPI();
  const frontApiPrefix = yield select(frontApiPrefixSelector);
  const proxyPrefix = yield select(proxyPrefixSelector);

  const baseUrl = `${proxyPrefix}${frontApiPrefix}`;

  const queryParams = yield call(getQueryParams, projects);
  const headers = yield call(getHeaders);

  const url = `${CENTRIFUGO_INITIAL_DATA_URL}?${queryParams}`;

  return yield call(fetch, url, {
    baseUrl,
    headers,
  });
}

export function* getCentrifugoInitialState(projects = []) {
  yield take(SET_CENTRIFUGO_CONNECTED);

  if (!projects?.length) {
    return;
  }

  try {
    const initialData = yield call(fetchCentrifugoInitialData, projects);
    logger.log('initial data', initialData);
    yield put(setCentrifugoInitialData(initialData));
  } catch (e) {
    logger.warn('error while requesting initial data', e);
  }
}
